<svg
  width="8"
  height="14"
  viewBox="0 0 8 14"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M6.88209 1.23084L1.1292 7.00006L6.88208 12.7693"
    stroke="#121835"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
